export default "__VITE_ASSET__pmYwNFbO__"